<template>
    <div class="product | u-wizard-padding-bottom">
        <div class="product__title">
            <h2>{{ trans('order.your-order') }}</h2>
        </div>

        <div class="product__item-header product__item-header-overview">
            <div class="u-flex-between">
                <span class="u-margin-bottom-responsive">
                    {{ domain.domain }}
                </span>
            </div>
        </div>

        <service-overview v-if="orderedService" :domain="domain" :productType="productType" />

        <div v-if="orderTotalPrice" class="product__totals">
            <span class="product__totals-content">
                <small class="u-margin-right">{{ trans('order.total') }}</small>
                <price-display :price="orderTotalPrice" class="product__totals-price" />
            </span>
        </div>
    </div>
</template>

<script>
import ServiceOverview from '../ServiceOverview.vue';
import PriceDisplay from '@/components/Price/PriceDisplay.vue';

export default {
    props: {
        domain: {
            type: Object,
            required: true,
            default: () => {}
        },
        orderedService: {
            type: Object,
            default: () => {}
        },
        orderTotalPrice: {
            type: Number,
            default: 0
        },
        productType: {
            type: String,
            required: true
        }
    },
    components: {
        ServiceOverview,
        PriceDisplay
    }
};
</script>
